module.exports = __webpack_public_path__ + "img/video_img4.f1852116.png";